import type { ComponentProps } from "react"

export default function Grip(props: ComponentProps<"svg"> & { fill?: string }) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="0.6rem"
      viewBox="0 0 6 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <rect y="0.5" width="2" height="2" fill={fill} />
      <rect y="4.5" width="2" height="2" fill={fill} />
      <rect y="8.5" width="2" height="2" fill={fill} />
      <rect x="4" y="0.5" width="2" height="2" fill={fill} />
      <rect x="4" y="4.5" width="2" height="2" fill={fill} />
      <rect x="4" y="8.5" width="2" height="2" fill={fill} />
    </svg>
  )
}
